import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

import { AUTH_TOKEN_API, REDIRECT_URL } from "constants/auth.constants";
import { IAccessTokenPayload } from "interfaces/auth.interface";
import { getAuthBaseUrl, shouldRefreshAccessToken } from "utils/auth.util";

type IAuthResponse = {
  refresh_token: string;
  access_token: string;
  expires_in: number;
  token_type: "Bearer";
  userId: string;
};

export type GetAuthTokenData = {
  code: string;
  client_id: string;
  code_verifier: string;
};

export function setTokens(response: IAuthResponse) {
  const decodedToken = jwtDecode<IAccessTokenPayload>(response.access_token);
  const accessTokenLifetime = response.expires_in || 0;
  const accessTokenExpiryTime = new Date();
  accessTokenExpiryTime.setTime(
    accessTokenExpiryTime.getTime() + accessTokenLifetime * 1000,
  );
  Cookies.set("access_token", response.access_token, {
    expires: accessTokenExpiryTime,
  });
  Cookies.set("userId", response.userId, {
    expires: accessTokenExpiryTime,
  });

  if (shouldRefreshAccessToken(decodedToken.roles)) {
    Cookies.set("refresh_token", response.refresh_token);
  }
}

export const getAuthToken = async (
  data: GetAuthTokenData,
): Promise<IAuthResponse> => {
  const url = getAuthBaseUrl() + AUTH_TOKEN_API;

  const res = await fetch(url, {
    method: "POST",
    body: new URLSearchParams({
      ...data,
      redirect_uri: `${document.location.origin}${REDIRECT_URL}`,
      grant_type: "authorization_code",
      scope: "offline_access",
    }),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });

  return await res.json();
};

type RefreshTokenData = {
  client_id: string;
  refresh_token: string;
};

export const refreshAuthToken = async (
  data: RefreshTokenData,
): Promise<IAuthResponse> => {
  const url = getAuthBaseUrl() + AUTH_TOKEN_API;

  const res = await fetch(url, {
    method: "POST",
    body: new URLSearchParams({ ...data, grant_type: "refresh_token" }),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });

  return await res.json();
};
